(function ( $ ) {
    $.fn.toggleNiceShow = function(init) {
        var elm = $(this);
        if(!elm.hasClass('has-nice-show')) {
            elm.addClass('has-nice-show');
            if(elm.is(':visible')) {
                elm.addClass('nice-show');
            } else {
                elm.css('display','block');
            }
        }
        if(elm.hasClass('nice-show')) {
            elm.removeClass('nice-show');
        } else {
            elm.addClass('nice-show');
        }
        return this;
    }
}( jQuery ));